<script lang="ts">
    import { ProgressCircular } from "svelte-materialify/src";
    import { Doc } from "sveltefire";
    export let computerScreen: boolean;
</script>

<div
    class={`d-flex justify-center align-center flex-column remove-break text-center ${
        computerScreen ? "home-container" : "home-container-mobile mt-14"
    }`}
>
    <Doc path={"about/intro"} traceId={"aboutIntroRead"} let:data={intro}>
        <h3 class="text-h3 primary-text home-margin">Hi there!</h3>
        <h5 class="text-h5 primary-text home-margin">
            My name's Alexander and I'm a <span class="span-underline"
                >{intro.position}</span
            >
            at {intro.company}
        </h5>
        <img
            src="Carpenter_Alexander_0085.jpg"
            alt="Alexander Carpenter"
            class={`home-margin ${
                computerScreen ? "image-main" : "image-mobile"
            }`}
        />
        <span slot="fallback">Error loading data</span>
        <span slot="loading">
            <ProgressCircular indeterminate color="primary" /></span
        >
    </Doc>
</div>

<style>
    .home-container {
        height: 100vh !important;
    }

    .home-container-mobile {
        height: calc(100vh - 56px) !important;
    }

    .span-underline {
        text-decoration: underline white !important;
    }

    .home-margin {
        margin: 20px !important;
    }

    .image-main {
        border-radius: 20px !important;
        width: 500px !important;
        height: 375px !important;
    }

    .image-mobile {
        border-radius: 20px !important;
        width: 300px !important;
        height: 225px !important;
    }
</style>
